import type { Lead } from '../types/portal'

export const leads: Lead[] = [
  {
    id: 'L-40219',
    name: 'Morgan Taylor',
    purpose: 'Purchase',
    amount: '$485,000',
    program: 'Conventional',
    market: 'Denver, CO',
    source: 'Zillow inquiry',
    assignedLabel: 'Assigned 18 minutes ago',
    lastContactLabel: null,
    status: 'new',
    phone: '(303) 555-0148',
    email: 'morgan.taylor@example.com',
    urgent: true,
  },
  {
    id: 'L-40214',
    name: 'Priya Raman',
    purpose: 'Purchase',
    amount: '$612,500',
    program: 'Jumbo',
    market: 'Boulder, CO',
    source: 'Realtor referral — Dana Whitfield',
    assignedLabel: 'Assigned 2 hours ago',
    lastContactLabel: null,
    status: 'new',
    phone: '(720) 555-0192',
    email: 'priya.raman@example.com',
    urgent: true,
  },
  {
    id: 'L-40208',
    name: 'Devin Brooks',
    purpose: 'Refinance',
    amount: '$329,000',
    program: 'FHA streamline',
    market: 'Aurora, CO',
    source: 'Website rate quote',
    assignedLabel: 'Assigned 6 hours ago',
    lastContactLabel: 'Voicemail logged 4 hours ago',
    status: 'new',
    phone: '(303) 555-0177',
    email: 'devin.brooks@example.com',
  },
  {
    id: 'L-40201',
    name: 'Alicia & Marco Serrano',
    purpose: 'Purchase',
    amount: '$398,750',
    program: 'VA',
    market: 'Littleton, CO',
    source: 'Open house sign-in',
    assignedLabel: 'Assigned yesterday',
    lastContactLabel: 'Email logged yesterday 7:50 PM',
    status: 'new',
    phone: '(720) 555-0134',
    email: 'serrano.family@example.com',
  },
  {
    id: 'L-40188',
    name: 'Yolanda Frey',
    purpose: 'Purchase',
    amount: '$402,000',
    program: 'Conventional',
    market: 'Westminster, CO',
    source: 'Past client referral',
    assignedLabel: 'Assigned 3 days ago',
    lastContactLabel: 'Call logged today 8:14 AM',
    status: 'working',
    phone: '(303) 555-0119',
    email: 'yolanda.frey@example.com',
  },
  {
    id: 'L-40176',
    name: 'Ibrahim Sallah',
    purpose: 'Purchase',
    amount: '$538,900',
    program: 'Conventional',
    market: 'Denver, CO',
    source: 'Realtor referral — Renee Ortiz',
    assignedLabel: 'Assigned 5 days ago',
    lastContactLabel: 'Call logged today 8:41 AM',
    status: 'working',
    phone: '(720) 555-0165',
    email: 'ibrahim.sallah@example.com',
  },
  {
    id: 'L-40154',
    name: 'Trevor Nguyen',
    purpose: 'Purchase',
    amount: '$588,000',
    program: 'Jumbo',
    market: 'Golden, CO',
    source: 'Open house sign-in',
    assignedLabel: 'Assigned 8 days ago',
    lastContactLabel: 'Video meeting logged today 9:30 AM',
    status: 'working',
    phone: '(303) 555-0102',
    email: 'trevor.nguyen@example.com',
  },
  {
    id: 'L-40131',
    name: 'Meredith Cole',
    purpose: 'Refinance',
    amount: '$276,400',
    program: 'Conventional',
    market: 'Lakewood, CO',
    source: 'Direct mail campaign',
    assignedLabel: 'Assigned 21 days ago',
    lastContactLabel: 'Text logged 9 days ago',
    status: 'nurture',
    phone: '(720) 555-0188',
    email: 'meredith.cole@example.com',
  },
  {
    id: 'L-40117',
    name: 'Grant Whitaker',
    purpose: 'Purchase',
    amount: '$355,000',
    program: 'FHA',
    market: 'Thornton, CO',
    source: 'Website rate quote',
    assignedLabel: 'Assigned 34 days ago',
    lastContactLabel: 'Call logged 16 days ago',
    status: 'nurture',
    phone: '(303) 555-0156',
    email: 'grant.whitaker@example.com',
  },
]
